import { styled } from "styled-components";

export const LevelSuccessContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Container = styled.div<{ $isPending: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  color: ${({ theme, $isPending }) => ($isPending ? theme.colors.warning : theme.colors.green)};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 120%;
  svg {
    width: 0.9375rem;
    height: 0.9375rem;
  }
`;

export default {
  Container,
};
